import Router from './pages/Router';

function App() {
  return (
    <Router/>
  );
}

export default App;
